module.exports = __webpack_public_path__ + "img/refuseApprovalIcon.cc7e2eac.png";